export default "__VITE_ASSET__Zeo5KtJj__"